'use client'

import { useContext, useState } from 'react'
import {
    Button,
    Dialog,
    DialogPanel,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
} from '@headlessui/react'
import {
    Bars3Icon,
    ChartPieIcon,
    CursorArrowRaysIcon,
    FingerPrintIcon,

    XMarkIcon,
} from '@heroicons/react/24/outline'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { HiSquaresPlus } from "react-icons/hi2";
import { PiBriefcaseMetalFill } from "react-icons/pi";
import { LuUserRoundSearch } from "react-icons/lu";
import { TbAdjustmentsSearch } from "react-icons/tb";
import { IoPersonAddOutline } from "react-icons/io5"
import { IoIosNotifications } from "react-icons/io";
import Logo from '../../../assets/CC ATS Logo.png'
// import Logo from '../../../assets/Merry ATS Christmas (5).gif'
import { DContext } from '../../../context/Datacontext'
import { CgProfile } from "react-icons/cg";
import { BiEdit } from "react-icons/bi";
import { IoLogOut } from "react-icons/io5";
import { renderImgUrl } from '../../../utils/renderImgUrl'


const imports = [
    { name: 'Import Candidates', description: 'Import Bulk Candidates from excel', href: '/import-candidate', icon: ChartPieIcon },
    { name: 'Import Candidate Info', description: `Import Bulk Candidate's Experience & Education from excel`, href: '/import-info', icon: FingerPrintIcon },
    { name: 'Import Resumes', description: 'Encrypt resumes files and update on Database', href: '/import-resume', icon: CursorArrowRaysIcon },
    // { name: 'Process Resume', description: 'Resume AUTO read and import', href: '/process-resume', icon: SquaresPlusIcon },
]

const accountOptions = [
    { name: 'Manage Account', description: '', href: '/account', icon: CgProfile },
    { name: 'Change Password', description: '', href: '/account', icon: BiEdit },
    { name: 'Logout', description: '', href: '/logout', icon: IoLogOut },
]

const users = [
    { name: "Create Organization", description: 'Create an Organization by providing company and Admin details', href: '/company-account', icon: HiSquaresPlus },
    { name: "Create User", description: 'Create a User by providing required details', href: '/create-users', icon: HiSquaresPlus },
    { name: "Manage Users", description: 'View, Update, and Delete Users', href: '/list-users', icon: PiBriefcaseMetalFill }
]

const clients = [
    { name: "Create Client", description: 'Create a Client by providing required details', href: '/create-client', icon: HiSquaresPlus },
    { name: "Manage Clients & Spocs", description: 'View, Update, and Delete Clients & Spocs', href: '/list-clients', icon: PiBriefcaseMetalFill }
]

const status = [
    { name: "Create Status", description: 'Create a Status by providing required details', href: '/list-status', icon: HiSquaresPlus },
    { name: "Manage Status", description: 'View, Update, and Delete Status', href: '/list-status', icon: PiBriefcaseMetalFill }
]

const empJobs = [
    { name: "Create Jobs", description: 'Create a Job by providing required details', href: '/create-job', icon: HiSquaresPlus },
    { name: "Manage Jobs", description: 'View, Update, and Delete Jobs', href: '/list-jobs', icon: PiBriefcaseMetalFill }
]

const empCandidates = [
    { name: "Search Candidates", description: 'Search Candidates by Name, Email, and Contact.', href: '/list-candidates', icon: LuUserRoundSearch },
    { name: "Pro Search Candidates", description: 'Search Candidates by advanced keyword and Filters.', href: '/pro-search', icon: TbAdjustmentsSearch },
    { name: "Create Candidate", description: 'Create new Candidate to save on Database.', href: '/create-candidate', icon: IoPersonAddOutline }
]

const reports = [
    { name: "EOD Submission Report", description: 'Tracks daily candidate submissions, updating only status changes when the same candidate is resubmitted.', href: '/eod-submission-reports', icon: HiSquaresPlus },
    { name: "EOD Action Report", description: 'Candidate’s status updates as separate rows, showing all actions taken throughout the day.', href: '/eod-reports', icon: HiSquaresPlus },
    // { name: "Recruitment Reports", description: 'Shows all EOD records filtered by periods like today, yesterday, monthly ranges, or custom date spans.', href: '/recruitment-reports', icon: PiBriefcaseMetalFill },
    { name: "Recruitment Reports", description: 'Shows all EOD records filtered by periods like today, yesterday, monthly ranges, or custom date spans.', href: '/recruitment', icon: PiBriefcaseMetalFill },
    { name: "Consolidated Reports", description: 'Consolidated view of all recruitment reports.', href: '/consolidated-reports', icon: PiBriefcaseMetalFill }

]

export default function Header() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const { isAuth, currentUser, count } = useContext(DContext)

    return (
        <div className={!isAuth && "px-4 md:px-16 lg:px-24 my-2"}>
            <header className="bg-gradient-to-r from-white via-white to-white text-white rounded-full shadow-lg">
                <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between p-2 px-6 sm:px-6 lg:px-8">
                    <div className="flex lg:flex-1">
                        <a href="/" className="-m-1.5 p-1.5 flex gap-2 items-center">
                            <img
                                alt="CC ATS Logo"
                                src={Logo}
                                className="h-[55px] md:h-[80px] w-auto rounded-xl"
                            />
                        </a>
                    </div>
                    <div className="flex lg:hidden">
                        <button
                            type="button"
                            onClick={() => setMobileMenuOpen(true)}
                            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-800"
                        >
                            <span className="sr-only">Open main menu</span>
                            <Bars3Icon aria-hidden="true" className="size-8" />
                        </button>
                    </div>
                    <PopoverGroup className="hidden lg:flex lg:gap-x-7">

                        <a href="/" className="text-sm/6 font-semibold text-gray-900">
                            {isAuth ? "Dashboard" : "Home"}

                        </a>

                        {
                            (isAuth && ["superadmin", "helpdesk"].includes(currentUser.role)) &&
                            <Popover className="relative">
                                <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
                                    Imports
                                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                                </PopoverButton>

                                <PopoverPanel
                                    transition
                                    className="absolute top-full -left-8 z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                                >
                                    <div className="p-4">
                                        {imports.map((item) => (
                                            <div
                                                key={item.name}
                                                className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                            >
                                                <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                    <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                                </div>
                                                <div className="flex-auto">
                                                    <a href={item.href} className="block font-semibold text-gray-900">
                                                        {item.name}
                                                        <span className="absolute inset-0" />
                                                    </a>
                                                    <p className="mt-1 text-gray-600">{item.description}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </PopoverPanel>
                            </Popover>}

                        {
                            (isAuth && !["superadmin", "helpdesk"].includes(currentUser.role)) &&
                            <Popover className="relative">
                                <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
                                    Jobs
                                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                                </PopoverButton>

                                <PopoverPanel
                                    transition
                                    className="absolute top-full -left-8 z-50 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                                >
                                    <div className="p-4">
                                        {empJobs.map((item) => {
                                            // if(currentUser.role === "recruiter" && item.href === "/create-job"){
                                            //     return null;
                                            // }
                                            // else{
                                            return (
                                                <div
                                                    key={item.name}
                                                    className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                                >
                                                    <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                        <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                                    </div>
                                                    <div className="flex-auto">
                                                        <a href={item.href} className="block font-semibold text-gray-900">
                                                            {item.name}
                                                            <span className="absolute inset-0" />
                                                        </a>
                                                        <p className="mt-1 text-gray-600">{item.description}</p>
                                                    </div>
                                                </div>
                                            )
                                            // }
                                        })}
                                    </div>
                                </PopoverPanel>
                            </Popover>}

                        {
                            (isAuth && !["superadmin", "helpdesk"].includes(currentUser.role)) &&
                            <Popover className="relative">
                                <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
                                    Candidates
                                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                                </PopoverButton>

                                <PopoverPanel
                                    transition
                                    className="absolute top-full -left-8 z-50 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                                >
                                    <div className="p-4">
                                        {empCandidates.map((item) => (
                                            <div
                                                key={item.name}
                                                className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                            >
                                                <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                    <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                                </div>
                                                <div className="flex-auto">
                                                    <a href={item.href} className="block font-semibold text-gray-900">
                                                        {item.name}
                                                        <span className="absolute inset-0" />
                                                    </a>
                                                    <p className="mt-1 text-gray-600">{item.description}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </PopoverPanel>
                            </Popover>}

                        {
                            (isAuth && !["superadmin", "helpdesk", 'recruiter'].includes(currentUser.role)) &&
                            <Popover className="relative">
                                <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
                                    Users
                                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                                </PopoverButton>

                                <PopoverPanel
                                    transition
                                    className="absolute top-full -left-8 z-50 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                                >
                                    <div className="p-4">
                                        {users.map((item) => {
                                            if (["admin", "manager", "teamlead", "recruiter"].includes(currentUser.role) && item.href !== "/company-account") {
                                                return (
                                                    <div
                                                        key={item.name}
                                                        className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                                    >
                                                        <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                            <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                                        </div>
                                                        <div className="flex-auto">
                                                            <a href={item.href} className="block font-semibold text-gray-900">
                                                                {item.name}
                                                                <span className="absolute inset-0" />
                                                            </a>
                                                            <p className="mt-1 text-gray-600">{item.description}</p>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            else {
                                                if (!["admin", "manager", "teamlead", "recruiter"].includes(currentUser.role)) {
                                                    return (
                                                        <div
                                                            key={item.name}
                                                            className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                                        >
                                                            <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                                <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                                            </div>
                                                            <div className="flex-auto">
                                                                <a href={item.href} className="block font-semibold text-gray-900">
                                                                    {item.name}
                                                                    <span className="absolute inset-0" />
                                                                </a>
                                                                <p className="mt-1 text-gray-600">{item.description}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                return null
                                            }
                                        })}
                                    </div>
                                </PopoverPanel>
                            </Popover>}

                        {
                            (isAuth && ["admin", "manager", "teamlead", 'recruiter'].includes(currentUser.role)) &&
                            <Popover className="relative">
                                <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
                                    Clients & Spocs
                                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                                </PopoverButton>

                                <PopoverPanel
                                    transition
                                    className="absolute top-full -left-8 z-50 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                                >
                                    <div className="p-4">
                                        {clients.map((item) => {
                                            if (["recruiter"].includes(currentUser.role) && item.href !== '/create-client') {
                                                return (
                                                    <div
                                                        key={item.name}
                                                        className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                                    >
                                                        <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                            <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                                        </div>
                                                        <div className="flex-auto">
                                                            <a href={item.href} className="block font-semibold text-gray-900">
                                                                {item.name}
                                                                <span className="absolute inset-0" />
                                                            </a>
                                                            <p className="mt-1 text-gray-600">{item.description}</p>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            else {
                                                if (["admin", "manager", "teamlead"].includes(currentUser.role))
                                                    return (
                                                        <div
                                                            key={item.name}
                                                            className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                                        >
                                                            <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                                <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                                            </div>
                                                            <div className="flex-auto">
                                                                <a href={item.href} className="block font-semibold text-gray-900">
                                                                    {item.name}
                                                                    <span className="absolute inset-0" />
                                                                </a>
                                                                <p className="mt-1 text-gray-600">{item.description}</p>
                                                            </div>
                                                        </div>
                                                    )
                                            }
                                            return null

                                        }
                                        )}
                                    </div>
                                </PopoverPanel>
                            </Popover>}

                        {
                            (isAuth && ["admin", "manager"].includes(currentUser.role)) &&
                            <Popover className="relative">
                                <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
                                    Status
                                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                                </PopoverButton>

                                <PopoverPanel
                                    transition
                                    className="absolute top-full -left-8 z-50 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                                >
                                    <div className="p-4">
                                        {status.map((item) => (
                                            <div
                                                key={item.name}
                                                className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                            >
                                                <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                    <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                                </div>
                                                <div className="flex-auto">
                                                    <a href={item.href} className="block font-semibold text-gray-900">
                                                        {item.name}
                                                        <span className="absolute inset-0" />
                                                    </a>
                                                    <p className="mt-1 text-gray-600">{item.description}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </PopoverPanel>
                            </Popover>}

                        {
                            (isAuth && !["superadmin", "helpdesk"].includes(currentUser.role)) &&
                            <Popover className="relative">
                                <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
                                    Reports
                                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                                </PopoverButton>

                                <PopoverPanel
                                    transition
                                    className="absolute top-full -left-8 z-50 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                                >
                                    <div className="p-4">
                                        {/* {reports.map((item) => {
                                            if (currentUser.role === "admin") {
                                                return (
                                                    <div
                                                        key={item.name}
                                                        className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                                    >
                                                        <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                            <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                                        </div>
                                                        <div className="flex-auto">
                                                            <a href={item.href} className="block font-semibold text-gray-900">
                                                                {item.name}
                                                                <span className="absolute inset-0" />
                                                            </a>
                                                            <p className="mt-1 text-gray-600">{item.description}</p>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            else if (currentUser.role !== "admin") {
                                                return (
                                                    <div
                                                        key={item.name}
                                                        className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                                    >
                                                        <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                            <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                                        </div>
                                                        <div className="flex-auto">
                                                            <a href={item.href} className="block font-semibold text-gray-900">
                                                                {item.name}
                                                                <span className="absolute inset-0" />
                                                            </a>
                                                            <p className="mt-1 text-gray-600">{item.description}</p>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            return null
                                        })} */}
                                            {reports.map((item) => {

                                                // Only Admin & Manager can access Consolidated Reports
                                                if (
                                                    item.href === "/consolidated-reports" &&
                                                    !["admin", "manager"].includes(currentUser.role)
                                                ) {
                                                    return null;
                                                }

                                                return (
                                                    <div
                                                        key={item.name}
                                                        className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                                    >
                                                        <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                            <item.icon
                                                                aria-hidden="true"
                                                                className="size-6 text-gray-600 group-hover:text-indigo-600"
                                                            />
                                                        </div>

                                                        <div className="flex-auto">
                                                            <a href={item.href} className="block font-semibold text-gray-900">
                                                                {item.name}
                                                                <span className="absolute inset-0" />
                                                            </a>

                                                            <p className="mt-1 text-gray-600">
                                                                {item.description}
                                                            </p>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </PopoverPanel>
                            </Popover>}

                        {(isAuth && ["admin", "manager"].includes(currentUser.role)) &&
                            <a href="/session-history" className="text-sm/6 font-semibold text-gray-900">
                                Log History
                            </a>}

                        {(isAuth && !["admin"].includes(currentUser.role)) && (
                            <a href="/notification" className="relative text-2xl font-semibold text-gray-900">
                                {/*Notification Icon */}
                                <IoIosNotifications />

                                {/*Badge — ONLY when count > 0 */}
                                {count > 0 && (
                                    <span className="absolute -top-1 -right-1 min-w-[10px] px-1 
                                     flex items-center justify-center 
                                      text-xs font-bold text-white 
                                     bg-red-600 rounded-full">
                                        {count}
                                    </span>
                                )}

                            </a>
                        )}



                    </PopoverGroup>
                    <div className="hidden lg:flex lg:flex-1 lg:justify-end">
                        {
                            isAuth &&
                            <Popover className="relative">
                                <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
                                    <img className='h-11 aspect-square rounded-full' src={renderImgUrl("", "", currentUser.fullName)} alt="profile" />
                                    My Account
                                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                                </PopoverButton>

                                <PopoverPanel
                                    transition
                                    className="absolute top-full -left-8 z-50 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white ring-1 shadow-lg ring-gray-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
                                >
                                    <div className="p-4">
                                        {accountOptions.map((item) => (
                                            <div
                                                key={item.name}
                                                className={`group relative flex items-center gap-x-6 rounded-lg py-1 px-2 text-sm/6 hover:bg-gray-50 ${item.href === "/logout" ? "text-red-500" : "text-gray-900"}`}
                                            >
                                                <div className="flex flex-none p-1 items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                    <item.icon aria-hidden="true" className="size-6 group-hover:text-indigo-600" />
                                                </div>
                                                <div className="flex-auto">
                                                    <a href={item.href} className="block font-semibold ">
                                                        {item.name}
                                                        <span className="absolute inset-0" />
                                                    </a>
                                                    <p className="mt-1 text-gray-600">{item.description}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </PopoverPanel>
                            </Popover>
                        }
                        {
                            !isAuth &&
                            <div className='flex gap-4'><Button
                                variant="white"
                                className="w-[100px] h-[38px] text-sm md:text-[16px] text-[#2c25c4] border border-[#2C25C4] rounded-md"
                                onClick={() => window.location.href = "/signin"}
                            >
                                Login
                            </Button>

                                <Button
                                    variant="primary"
                                    className="w-[100px] h-[38px] text-white text-sm md:text-[16px] bg-primary-300 rounded-md"
                                    onClick={() => window.location.href = "/signin"}
                                >
                                    Register
                                </Button>
                            </div>
                        }
                    </div>
                </nav>
                <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
                    <div className="fixed inset-0 z-10" />
                    <DialogPanel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white p-2 sm:p-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                        <div className="flex items-center justify-between">
                            <a href="/" className="-m-1.5 p-1.5 flex gap-1 items-center">
                                <img
                                    alt="App Logo"
                                    src={Logo}
                                    className="h-[50px] w-auto rounded-xl"
                                />
                                {/* <span className="text-lg font-bold text-primary-400">CC Ai</span> */}
                            </a>
                            <button
                                type="button"
                                onClick={() => setMobileMenuOpen(false)}
                                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                            >
                                <span className="sr-only">Close menu</span>
                                <XMarkIcon aria-hidden="true" className="size-6" />
                            </button>
                        </div>
                        <div className="mt-6 flow-root">
                            <div className="-my-6 divide-y divide-gray-500/10">
                                <div className="space-y-2 py-6">

                                    <a
                                        href="/"
                                        className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                    >
                                        {isAuth ? "Dashboard" : "Home"}
                                    </a>

                                    {
                                        (isAuth && ["superadmin", "helpdesk"].includes(currentUser.role)) &&
                                        <Disclosure as="div" className="-mx-3">
                                            <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                                Imports
                                                <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-open:rotate-180" />
                                            </DisclosureButton>
                                            <DisclosurePanel className="mt-2 space-y-2">
                                                {[imports].map((item) => (
                                                    <DisclosureButton
                                                        key={item.name}
                                                        as="a"
                                                        href={item.href}
                                                        className="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                    >
                                                        {item.name}
                                                    </DisclosureButton>
                                                ))}
                                            </DisclosurePanel>
                                        </Disclosure>}


                                    {
                                        (isAuth && !["superadmin", "helpdesk"].includes(currentUser.role)) &&
                                        <Disclosure as="div" className="-mx-3">
                                            <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                                Jobs
                                                <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-open:rotate-180" />
                                            </DisclosureButton>
                                            <DisclosurePanel className="mt-2 space-y-2">
                                                {empJobs.map((item) => {
                                                    // if(currentUser.role === "recruiter" && item.href === "/create-job"){
                                                    //     return null;
                                                    // }
                                                    // else{
                                                    return (
                                                        <DisclosureButton
                                                            key={item.name}
                                                            as="a"
                                                            href={item.href}
                                                            className="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                        >
                                                            {item.name}
                                                        </DisclosureButton>
                                                    )
                                                    // }
                                                })}
                                            </DisclosurePanel>
                                        </Disclosure>}

                                    {
                                        (isAuth && !["superadmin", "helpdesk"].includes(currentUser.role)) &&
                                        <Disclosure as="div" className="-mx-3">
                                            <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                                Candidates
                                                <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-open:rotate-180" />
                                            </DisclosureButton>
                                            <DisclosurePanel className="mt-2 space-y-2">
                                                {empCandidates.map((item) => (
                                                    <DisclosureButton
                                                        key={item.name}
                                                        as="a"
                                                        href={item.href}
                                                        className="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                    >
                                                        {item.name}
                                                    </DisclosureButton>
                                                ))}
                                            </DisclosurePanel>
                                        </Disclosure>}

                                    {
                                        (isAuth && !["superadmin", "helpdesk", "recruiter"].includes(currentUser.role)) &&
                                        <Disclosure as="div" className="-mx-3">
                                            <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                                Users
                                                <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-open:rotate-180" />
                                            </DisclosureButton>
                                            <DisclosurePanel className="mt-2 space-y-2">
                                                {users.map((item) => {
                                                    if (["admin", "manager", "teamlead", "recruiter"].includes(currentUser.role) && item.href !== "/company-account") {
                                                        return (
                                                            <DisclosureButton
                                                                key={item.name}
                                                                as="a"
                                                                href={item.href}
                                                                className="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                            >
                                                                {item.name}
                                                            </DisclosureButton>
                                                        )
                                                    }
                                                    else if (!["admin", "manager", "teamlead", "recruiter"].includes(currentUser.role)) {
                                                        return (
                                                            <DisclosureButton
                                                                key={item.name}
                                                                as="a"
                                                                href={item.href}
                                                                className="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                            >
                                                                {item.name}
                                                            </DisclosureButton>
                                                        )
                                                    }
                                                    return null
                                                })}
                                            </DisclosurePanel>
                                        </Disclosure>}

                                    {
                                        (isAuth && ["admin", "manager", "teamlead", 'recruiter'].includes(currentUser.role)) &&
                                        <Disclosure as="div" className="-mx-3">
                                            <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                                Clients & SPOCs
                                                <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-open:rotate-180" />
                                            </DisclosureButton>
                                            <DisclosurePanel className="mt-2 space-y-2">
                                                {clients.map((item) => {
                                                    if (["recruiter"].includes(currentUser.role) && item.href !== '/create-client') {
                                                        return (
                                                            <DisclosureButton
                                                                key={item.name}
                                                                as="a"
                                                                href={item.href}
                                                                className="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                            >
                                                                {item.name}
                                                            </DisclosureButton>
                                                        )
                                                    }
                                                    else if (["admin", "manager", "teamlead"].includes(currentUser.role)) {
                                                        return (
                                                            <DisclosureButton
                                                                key={item.name}
                                                                as="a"
                                                                href={item.href}
                                                                className="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                            >
                                                                {item.name}
                                                            </DisclosureButton>
                                                        )
                                                    }
                                                    return null
                                                })}
                                            </DisclosurePanel>
                                        </Disclosure>}

                                    {
                                        (isAuth && ["admin", "manager"].includes(currentUser.role)) &&
                                        <Disclosure as="div" className="-mx-3">
                                            <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                                Status
                                                <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-open:rotate-180" />
                                            </DisclosureButton>
                                            <DisclosurePanel className="mt-2 space-y-2">
                                                {status.map((item) => (
                                                    <DisclosureButton
                                                        key={item.name}
                                                        as="a"
                                                        href={item.href}
                                                        className="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                    >
                                                        {item.name}
                                                    </DisclosureButton>
                                                ))}
                                            </DisclosurePanel>
                                        </Disclosure>}

                                    {
                                        (isAuth && !["superadmin", "helpdesk"].includes(currentUser.role)) &&
                                        <Disclosure as="div" className="-mx-3">
                                            <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                                Reports
                                                <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-open:rotate-180" />
                                            </DisclosureButton>
                                            <DisclosurePanel className="mt-2 space-y-2">
                                                {reports.map((item) => {
                                                    if (currentUser.role === "admin" && item.href !== "/eod-reports" && item.href !== "/eod-submission-reports") {
                                                        return (
                                                            <DisclosureButton
                                                                key={item.name}
                                                                as="a"
                                                                href={item.href}
                                                                className="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                            >
                                                                {item.name}
                                                            </DisclosureButton>
                                                        )
                                                    }
                                                    else if (currentUser.role !== "admin") {
                                                        return (
                                                            <DisclosureButton
                                                                key={item.name}
                                                                as="a"
                                                                href={item.href}
                                                                className="block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                                            >
                                                                {item.name}
                                                            </DisclosureButton>
                                                        )
                                                    }
                                                    return null
                                                })}
                                            </DisclosurePanel>
                                        </Disclosure>}


                                    {(isAuth && ["admin", "manager"].includes(currentUser.role)) &&
                                        <a href="/session-history" className="text-sm/6 font-semibold text-gray-900">
                                            Log History
                                        </a>}

                                    {(isAuth && !["admin"].includes(currentUser.role)) &&
                                        <a href="/notification" className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                            Notification
                                        </a>
                                    }

                                </div>
                                <div className="py-6">
                                    {
                                        isAuth &&
                                        <Disclosure as="div" className="-mx-3">
                                            <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                                <img className='h-11 aspect-square rounded-full' src={renderImgUrl("", "", currentUser.fullName)} alt="profile" />
                                                My Account
                                                <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-open:rotate-180" />
                                            </DisclosureButton>
                                            <DisclosurePanel className="mt-2 space-y-2">
                                                {accountOptions.map((item) => (
                                                    <DisclosureButton
                                                        key={item.name}
                                                        as="a"
                                                        href={item.href}
                                                        className={`block rounded-lg py-2 pr-3 pl-6 text-sm/7 font-semibold hover:bg-gray-50 ${item.href === "/logout" ? "text-red-500" : "text-gray-900"}`}
                                                    >
                                                        {item.name}
                                                    </DisclosureButton>
                                                ))}
                                            </DisclosurePanel>
                                        </Disclosure>

                                    }
                                    {
                                        !isAuth &&
                                        <div className='flex gap-5 justify-center'>
                                            <Button
                                                variant="white"
                                                className="w-[200px] h-[38px] text-sm md:text-[16px] text-[#2c25c4] border border-[#2C25C4] rounded-md"
                                                onClick={() => window.location.href = "/signin"}
                                            >
                                                Login
                                            </Button>

                                            <Button
                                                variant="primary"
                                                className="w-[200px] h-[38px] text-white text-sm md:text-[16px] bg-primary-300 rounded-md"
                                                onClick={() => window.location.href = "/signin"}
                                            >
                                                Try now
                                            </Button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </DialogPanel>
                </Dialog>
            </header>
        </div>
    )
}
